// extracted by mini-css-extract-plugin
export var disabledCursor = "menu-select-widget-module--disabled-cursor--98956";
export var dropdownCustomChevron = "menu-select-widget-module--dropdown-custom-chevron--96912";
export var selectContainer = "menu-select-widget-module--select-container--7bca0";